import { createSlice } from '@reduxjs/toolkit';
import actionListaAgendamentos from 'src/actions/agendamentos/actionListaCampanhas';

// ----------------------------------------------------------------------
// `listaCampanhas`/`getListaCampanhas` viviam aqui e nao tinham nenhum consumidor:
// a tela de Campanhas sempre manteve a lista em estado local. A tela nova segue o
// padrao de Propostas (estado local + service), entao o slice cuida so dos
// agendamentos.
const initialState = {
  isLoading: false,
  error: false,
  listaAgendamentos: []
};

const slice = createSlice({
  name: 'marketing',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    // LISTA DE MENSAGENS AGENDADAS
    getListaMensagensAgendadasSuccess(state, action) {
      state.isLoading = false;
      state.listaAgendamentos = action.payload;
    }

  }
});

// Reducer
export default slice.reducer;

export const { actions } = slice;

// ----------------------------------------------------------------------

export function getListaMensagensAgendadas(clienteId, usuarioId) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await actionListaAgendamentos(clienteId, usuarioId);
      dispatch(slice.actions.getListaMensagensAgendadasSuccess(response.data.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
